import React from "react";
import { X, Search } from "lucide-react";

export const PriceLookupModal = ({
  lookupResults,
  setLookupResults,
  lookupItemIndex,
  setLookupItemIndex,
  items,
  applyLookupResult
}) => {
  if (!lookupResults || lookupResults.length === 0) return null;

  return (
    <div 
      className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-4"
      onClick={() => { setLookupResults(null); setLookupItemIndex(null); }}
    >
      <div 
        className="relative bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white">
          <div className="flex items-center gap-2">
            <Search className="w-5 h-5" />
            <span className="font-medium">Seleccionar Precio de Lista</span>
          </div>
          <button
            onClick={() => { setLookupResults(null); setLookupItemIndex(null); }}
            className="p-1 hover:bg-white/20 rounded-full transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        
        {/* Current item info */}
        {lookupItemIndex !== null && items[lookupItemIndex] && (
          <div className="px-4 py-3 bg-blue-50 border-b">
            <div className="text-xs text-blue-600 font-medium mb-1">Buscando precio para:</div>
            <div className="text-sm font-medium text-slate-800">
              {items[lookupItemIndex].description || items[lookupItemIndex].item_code || "Item sin descripción"}
            </div>
            <div className="text-xs text-slate-500 mt-1">
              {[items[lookupItemIndex].series, items[lookupItemIndex].material, items[lookupItemIndex].color]
                .filter(Boolean).join(" · ") || "Sin especificaciones"}
            </div>
          </div>
        )}
        
        {/* Results list */}
        <div className="overflow-auto max-h-[50vh]">
          {lookupResults.map((type, idx) => (
            <div
              key={type.id || idx}
              className={`px-4 py-3 border-b hover:bg-slate-50 cursor-pointer transition-colors ${
                type.isAutoMatch ? 'bg-green-50 border-l-4 border-l-green-500' : ''
              }`}
              onClick={() => applyLookupResult(type)}
            >
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="font-medium text-slate-800">{type.name}</span>
                    {type.isAutoMatch && (
                      <span className="px-2 py-0.5 bg-green-100 text-green-700 text-xs rounded-full">
                        Mejor coincidencia
                      </span>
                    )}
                  </div>
                  <div className="text-xs text-slate-500 mt-1">
                    {[type.series, type.material, type.color].filter(Boolean).join(" · ") || "Sin especificaciones"}
                  </div>
                </div>
                <div className="text-right ml-4">
                  <div className="text-lg font-bold text-blue-600">
                    ${(type.average_cost_per_m2 || 0).toFixed(2)}
                  </div>
                  <div className="text-xs text-slate-500">por m²</div>
                </div>
              </div>
              {type.image_data && (
                <div className="mt-2">
                  <img 
                    src={type.image_data} 
                    alt="" 
                    className="w-12 h-12 object-contain border rounded"
                  />
                </div>
              )}
            </div>
          ))}
        </div>
        
        {/* Footer */}
        <div className="px-4 py-3 bg-slate-100 border-t text-center">
          <span className="text-xs text-slate-500">
            Haz clic en un tipo para aplicar su precio al item
          </span>
        </div>
      </div>
    </div>
  );
};
